import { useEffect, useState } from "react";
import { Brush, Wallet } from "lucide-react";
import { adminApi } from "../../lib/api";

const rs = (n) => `₹${Number(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const PERIODS = [["today", "Aaj"], ["week", "Is Hafte"], ["month", "Is Mahine"]];
const sum = (rows, k) => rows.reduce((a, r) => ({ amount: a.amount + r[k].amount, count: a.count + r[k].count }), { amount: 0, count: 0 });

const Report = ({ title, icon: Icon, rows, tid, color }) => (
  <section data-testid={tid} className="border border-white/10 bg-[#0F172A] p-5">
    <h2 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-white"><Icon className={`h-5 w-5 ${color}`} />{title}</h2>
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      {PERIODS.map(([k, label]) => {
        const t = sum(rows, k);
        return (
          <div key={k} data-testid={`${tid}-${k}`} className="border border-emerald-500/20 bg-emerald-500/5 p-4 text-center">
            <p className="font-mono text-[11px] uppercase tracking-wider text-slate-400">{label}</p>
            <p className="mt-1 font-heading text-3xl font-extrabold text-emerald-400">{rs(t.amount)}</p>
            <p className="text-xs text-slate-500">{t.count} payment</p>
          </div>
        );
      })}
    </div>
    {rows.length > 1 && (
      <div className="mt-4 overflow-x-auto">
        <table className="w-full min-w-[520px] text-sm">
          <thead><tr className="border-b border-white/10 text-left text-slate-400">
            <th className="py-2 font-medium">Source</th>
            {PERIODS.map(([k, label]) => <th key={k} className="py-2 text-right font-medium">{label}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.kind} data-testid={`${tid}-row-${r.kind}`} className="border-b border-white/5">
                <td className="py-2 font-semibold text-slate-200">{r.label}</td>
                {PERIODS.map(([k]) => <td key={k} className="py-2 text-right font-mono text-white">{rs(r[k].amount)} <span className="text-slate-500">({r[k].count})</span></td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </section>
);

export const EarningsReport = ({ refreshKey }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    adminApi.get("/admin/payments/earnings").then((r) => setD(r.data)).catch(() => {});
  }, [refreshKey]);
  if (!d) return null;
  return (
    <div data-testid="earnings-report" className="grid grid-cols-1 gap-6 xl:grid-cols-2">
      <Report title="Services Earnings" icon={Brush} color="text-orange-400" tid="earnings-services" rows={d.rows.filter((r) => r.kind.startsWith("hk_"))} />
      <Report title="Employer Wallet Recharge" icon={Wallet} color="text-sky-400" tid="earnings-wallet" rows={d.rows.filter((r) => r.kind === "wallet")} />
    </div>
  );
};
